var colors = require("./../colors/colors");

var GridInteractionHandleView = require("./gridInteractionHandleView.js");

var GridInteractionView = {
    addGridInteractionView : function (editorView, interactionModel, parentGroup, layers) {
        var self = this;
        this.handles = [];

        this.interactionModel = interactionModel;

        this.editorView = editorView;
        this.gui = this.editorView; // TODO: legacy
        this.cameraModel = this.gui.editorModel.cameraModel();

        this.gridSvgGroup = this.editorView.svg.group(this.getGroupInfo(layers.draw).svgGroup);

        if (this.interactionModel.handles) {
            this.interactionModel.handles.toArray().forEach(function (obj, idx) {
                self.handles.push(new GridInteractionHandleView(self, editorView, idx, obj, parentGroup, layers));
            });
        }

        var scheduleRedraw = function () {
            self.gui.heavyHandler.scheduleHeavy('rebuild_grid_view', self.drawGrid, self, [], self);
        };

        this.interactionModel.hidden.onChange({}, scheduleRedraw);
        this.cameraModel.viewS.onChange({}, scheduleRedraw);
        this.interactionModel.gPos.onChange(self, scheduleRedraw);
        this.interactionModel.gHeight.onChange(self, scheduleRedraw);
        this.interactionModel.gWidth.onChange(self, scheduleRedraw);
        this.interactionModel.gAngle.onChange(self, scheduleRedraw);
        this.interactionModel.gXflip.onChange(self, scheduleRedraw);
        this.interactionModel.gYflip.onChange(self, scheduleRedraw);

        this.drawGrid();
    },

    drawGrid : function () {
        $(this.gridSvgGroup).empty();

        if(!this.interactionModel.isAlive()) return;
        if(this.interactionModel.hidden()) return;

        var stroke = 1 / this.cameraModel.viewS();
        var pos = this.interactionModel.gPos();
        var centerX = pos.getX();
        var centerY = pos.getY();
        this.gui.svg.rect(this.gridSvgGroup,
            centerX - this.interactionModel.gWidth()/2,
            centerY - this.interactionModel.gHeight()/2,
            this.interactionModel.gWidth(), this.interactionModel.gHeight(), {
            'fill': 'none',
            'stroke': colors.handleViewOutlineStroke,
            'strokeWidth': stroke,
            'transform': (this.interactionModel.gAngle ?
                (this.interactionModel.gAngle() ? 'rotate(' + this.interactionModel.gAngle() + ' ' +
                centerX + ' ' + centerY + ')' : '') : '')
        });
    }
};

module.exports = GridInteractionView;

